import Vue from 'vue'
export default class fvPerformanceServer {
    constructor(parent,options){
        this.system = parent;
        this._options = options
        this.db = parent.dbCom;  
        this.objName = options.name;
        this.getPro();
    }
    async getPerformanceInfo(){
        return await new Promise((resolve, reject)=>{
            this.db.sendMessage(this._additionalConfig({
                name : this.objName,
                fctype : "fvPerformanceServer",
            }),async (err,result)=>{
                if(err){
                    console.log(err);
                    resolve([]);
                }else if(result){
                    if(result.length != undefined){
                        resolve(result)
                    }else{
                        resolve([result])
                    }
                    
                }else{
                    resolve([])
                }
            });
        }) 
    }
    

   
    getPro(){
        
           /**
             * 获取cpu使用率
             * 
            */
        Object.defineProperty(this,"GetCPUValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].cpuUsedRate);
                }else{
                    return; 
                }
            }
        })
           /**
             * 获取cpu核数
             * 
            */
        Object.defineProperty(this,"GetCPUKernelValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].cpuNums);
                }else{
                    return; 
                }
            }
        })
        /**
         * 获取内存值
         * 
         */
        Object.defineProperty(this,"GetMemoryValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].totalMem);
                }else{
                    return; 
                }
            }
        })
         /**
         * 获取内存使用值
         * 
         */
        Object.defineProperty(this,"GetMemoryUsedValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].memUsed);
                }else{
                    return; 
                }
            }
        })
         /**
         * 获取内存剩余值
         * 
         */
        Object.defineProperty(this,"GetMemorySurplusValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].totalMem) - parseFloat(result[0].memUsed);
                }else{
                    return; 
                }
            }
        })
        /**
         * 获取磁盘
         */
        Object.defineProperty(this,"GetDiskValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].totalDisk);
                }else{
                    return; 
                }
            }
        })
        /**
         * 获取磁盘使用
         */
        Object.defineProperty(this,"GetDiskUsedValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].diskUsed);
                }else{
                    return; 
                }
            }
        })
        /**
         * 获取磁盘剩余
         */
        Object.defineProperty(this,"GetDiskSurplusValue",{
            set(value){
                return value;
            },
            async get(){
                let result = await this.getPerformanceInfo();
                if(result[0]){
                    return parseFloat(result[0].totalDisk) - parseFloat(result[0].diskUsed);
                }else{
                    return; 
                }
            }
        })
     }
     
    /*
    功能：附加sql语句到报文。私有函数，外部不可对报文进行修改
    */
    _additionalConfig(config){
        return {
            head : "backstage",
            message : {
                head : "fvPerformanceServer",
                type : "api",
                message : config
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvPerformanceServer/index.js